$(document).ready(function () {
    let body = $('body'),
        mobileFilterBlock = $('.sidebar__insights-mobile'),
        blogCategory = $('.blog-category'),
        postsPerPage = blogCategory.data('per-page'),
        isInitializing = true;

    $('#wrapper').addClass('tech-insights');

    setTimeout(function () {
        isInitializing = false;
    }, 1000);

    $('.sidebar__topic-js p').on('click', function (event) {
        $(this).parent().siblings().removeClass('active-filter');
        $(this).parent().toggleClass('active-filter');
        event.stopPropagation();
    });
    $(document).on('click', function (event) {
        // Проверка, был ли клик внутри .career-sidebar__filter
        if (!$(event.target).closest('.career-sidebar__filter').length) {
            $('.sidebar__topic-js').removeClass('active-filter');
        }
    });

    $('.sidebar__container-title').on('click', function () {
        const $this = $(this);
        $this.toggleClass('active');
        $this.next('.career-sidebar__filter').toggleClass('active');
        scrollToInsights();
    });

    $(
        '.filter__mobile, .filter__mobile-inside, .button__apply-filter-insights'
    ).on('click', function (e) {
        e.preventDefault();

        const filterMobileInsideButton = $('.filter__mobile-inside');

        filterMobileInsideButton.toggleClass('active');
        mobileFilterBlock.toggleClass('active');

        if (filterMobileInsideButton.hasClass('active')) {
            if ($('.header').hasClass('header--hidden')) {
                mobileFilterBlock.css('top', 0 + 'px');
            } else {
                mobileFilterBlock.css('top', $('.header').outerHeight() + 'px');
            }

            body.css('overflow', 'hidden');

            setTimeout(() => {
                mobileFilterBlock.css('bottom', 0);
            }, 500);

            // bodyScrollLock.disableBodyScroll(body);
        } else {
            mobileFilterBlock.css('top', '-2000px').css('bottom', '');
            body.css('overflow', '');

            // bodyScrollLock.enableBodyScroll(body);
            // bodyScrollLock.clearAllBodyScrollLocks();
        }
    });


    const windowWidth = window.innerWidth;

    let serviceTypes = [];
    let industries = [];
    let expertises = [];

    $(window).on('stopResize orientationchange', function (event) {
        if (window.innerWidth < 1201 && windowWidth > 1200) {
            window.location.reload();
        }
        if (window.innerWidth > 1200 && windowWidth < 1201) {
            window.location.reload();
        }

        if (window.innerWidth < 992 && windowWidth > 991) {
            window.location.reload();
        }
        if (window.innerWidth > 991 && windowWidth < 992) {
            window.location.reload();
        }
        if (window.innerWidth < 641 && windowWidth > 640) {
            window.location.reload();
        }
        if (window.innerWidth > 640 && windowWidth < 641) {
            window.location.reload();
        }
    });

    $(window).on('popstate', function () {
        const url = new URL(window.location.href);

        const urlWithoutParams = url.origin + url.pathname;
        const searchParams = url.searchParams;

        if (searchParams.has('current_page')) {
            searchParams.delete('current_page');
        }

        if (searchParams.size > 0 || searchParams.toString().length > 0) {
            window.location.href =
                urlWithoutParams + '?' + searchParams.toString();
        } else {
            window.location.href = urlWithoutParams;
        }
    });

    function scrollToInsights() {
        if (window.innerWidth > 992) {
            $('html, body').animate(
                {
                    scrollTop: $('.blog-page').offset().top - 80 + 'px',
                },
                500
            );
        }
    }

    function clearAllFilters() {
        serviceTypes = [];
        industries = [];
        expertises = [];
        $('[data-service-type]').removeClass('active');
        $('[data-industry]').removeClass('active');
        $('[data-expertise]').removeClass('active');

        // window.location = window.location.pathname;
        // history.pushState(null, '', window.location.pathname);
    }

    if (window.innerWidth <= 1200) {
        $(document).on(
            'click',
            '.button__clear-filter-insights__mobile',
            function () {
                clearAllFilters();
            }
        );
    } else {
        $(document).on('click', '.button__clear-filter-insights', function () {
            clearAllFilters();
        });
    }

    function checkSelectAllButton() {
        let serviceTypesAllSelected = true;
        let industriesAllSelected = true;
        let expertisesAllSelected = true;

        if (window.innerWidth <= 1200) {
            $.each(
                $(
                    '.sidebar__insights-mobile__internal .js-filter-item_service_types'
                ),
                function (index, obj) {
                    if (!$(obj).hasClass('active')) {
                        serviceTypesAllSelected = false;
                    }
                }
            );

            $.each(
                $(
                    '.sidebar__insights-mobile__internal .js-filter-item_industries'
                ),
                function (index, obj) {
                    if (!$(obj).hasClass('active')) {
                        industriesAllSelected = false;
                    }
                }
            );

            $.each(
                $(
                    '.sidebar__insights-mobile__internal .js-filter-item_expertises'
                ),
                function (index, obj) {
                    if (!$(obj).hasClass('active')) {
                        expertisesAllSelected = false;
                    }
                }
            );

            if (serviceTypesAllSelected) {
                $(
                    '.sidebar__insights-mobile__internal .js-filter-item__all[data-filter="service-type"]'
                )
                    .addClass('active')
                    .text('Clear all');
            } else {
                $(
                    '.sidebar__insights-mobile__internal .js-filter-item__all[data-filter="service-type"]'
                )
                    .removeClass('active')
                    .text('Select all');
            }
            if (industriesAllSelected) {
                $(
                    '.sidebar__insights-mobile__internal .js-filter-item__all[data-filter="industries"]'
                )
                    .addClass('active')
                    .text('Clear all');
            } else {
                $(
                    '.sidebar__insights-mobile__internal .js-filter-item__all[data-filter="industries"]'
                )
                    .removeClass('active')
                    .text('Select all');
            }
            if (expertisesAllSelected) {
                $(
                    '.sidebar__insights-mobile__internal .js-filter-item__all[data-filter="expertise"]'
                )
                    .addClass('active')
                    .text('Clear all');
            } else {
                $(
                    '.sidebar__insights-mobile__internal .js-filter-item__all[data-filter="expertise"]'
                )
                    .removeClass('active')
                    .text('Select all');
            }
        } else {
            $.each(
                $('.sidebar__insights .js-filter-item_service_types'),
                function (index, obj) {
                    if (!$(obj).hasClass('active')) {
                        serviceTypesAllSelected = false;
                    }
                }
            );

            $.each(
                $('.sidebar__insights .js-filter-item_industries'),
                function (index, obj) {
                    if (!$(obj).hasClass('active')) {
                        industriesAllSelected = false;
                    }
                }
            );

            $.each(
                $('.sidebar__insights .js-filter-item_expertises'),
                function (index, obj) {
                    if (!$(obj).hasClass('active')) {
                        expertisesAllSelected = false;
                    }
                }
            );

            if (serviceTypesAllSelected) {
                $(
                    '.sidebar__insights .js-filter-item__all[data-filter="service-type"]'
                )
                    .addClass('active')
                    .text('Clear all');
            } else {
                $(
                    '.sidebar__insights .js-filter-item__all[data-filter="service-type"]'
                )
                    .removeClass('active')
                    .text('Select all');
            }
            if (industriesAllSelected) {
                $(
                    '.sidebar__insights .js-filter-item__all[data-filter="industries"]'
                )
                    .addClass('active')
                    .text('Clear all');
            } else {
                $(
                    '.sidebar__insights .js-filter-item__all[data-filter="industries"]'
                )
                    .removeClass('active')
                    .text('Select all');
            }
            if (expertisesAllSelected) {
                $(
                    '.sidebar__insights .js-filter-item__all[data-filter="expertise"]'
                )
                    .addClass('active')
                    .text('Clear all');
            } else {
                $(
                    '.sidebar__insights .js-filter-item__all[data-filter="expertise"]'
                )
                    .removeClass('active')
                    .text('Select all');
            }
        }
    }

    function setSelectedFilterList() {
        let innerHtml = '';

        $.each(serviceTypes, function (i) {
            innerHtml +=
                '<button type="button" class="filter-item sidebar__result-filter__item js-filter-item js-filter-item--service-type" data-service-type="' +
                serviceTypes[i] +
                '">' +
                serviceTypes[i] +
                '</button>';
        });

        $.each(industries, function (i) {
            innerHtml +=
                '<button type="button" class="filter-item sidebar__result-filter__item js-filter-item js-filter-item--industry" data-industry="' +
                industries[i] +
                '">' +
                industries[i] +
                '</button>';
        });

        $.each(expertises, function (i) {
            innerHtml +=
                '<button type="button" class="filter-item sidebar__result-filter__item js-filter-item js-filter-item--expertise" data-expertise="' +
                expertises[i] +
                '">' +
                expertises[i] +
                '</button>';
        });

        if (innerHtml.length) {
            let html = innerHtml;
            if (window.innerWidth <= 1200) {
                html +=
                    '<button type="button" class="button__clear-filter-insights__mobile filter-item">Clear All Filters</button>';
            } else {
                html +=
                    '<button type="button" class="button__clear-filter-insights filter-item">Clear All Filters</button>';
            }

            $('.sidebar__result-filter').addClass('active');
            $('.sidebar__result-filter-container').html(html);
        } else {
            $('.sidebar__result-filter').removeClass('active');

            const html = '';
            $('.sidebar__result-filter-container').html(html);
        }
    }

    function parseUrlParamsInit() {
        const urlParams = new URLSearchParams(window.location.search);
        const filters = urlParams.get('filters');

        serviceTypes = [];
        industries = [];
        expertises = [];

        if (filters) {
            const filterSlugs = filters.split(',');
            filterSlugs.forEach((slug) => {
                slug = slug.trim();
                if (!slug) {
                    return;
                }

                // Check which taxonomy this slug belongs to
                const serviceTypeEl = $('[data-service-type="' + slug + '"]');
                const industryEl = $('[data-industry="' + slug + '"]');
                const expertiseEl = $('[data-expertise="' + slug + '"]');

                if (serviceTypeEl.length) {
                    serviceTypes.push(slug);
                    serviceTypeEl.addClass('active');
                } else if (industryEl.length) {
                    industries.push(slug);
                    industryEl.addClass('active');
                } else if (expertiseEl.length) {
                    expertises.push(slug);
                    expertiseEl.addClass('active');
                }
            });

            const activeCount =
                serviceTypes.length + industries.length + expertises.length;
            setTimeout(() => {
                if (activeCount === 1) {
                    const activeValue =
                        serviceTypes[0] || industries[0] || expertises[0];

                    $('.tab-item')
                        .filter(function () {
                            return (
                                $(this).data('service-type') === activeValue ||
                                $(this).data('industry') === activeValue ||
                                $(this).data('expertise') === activeValue
                            );
                        })
                        .addClass('active');
                }
            }, 4000);

            // Content is already server-rendered, just update UI
            setSelectedFilterList();
        } else {
            $('.loader__block').css('display', 'none');
        }
    }

    function getAllSelectedSlugs() {
        let allSlugs = [];
        allSlugs = allSlugs.concat(serviceTypes);
        allSlugs = allSlugs.concat(industries);
        allSlugs = allSlugs.concat(expertises);
        return allSlugs;
    }

    function ajaxQueryApply(page = 1, filterItem = null, skipScroll = false) {
        if (isInitializing) {
            return;
        }

        const allSlugs = getAllSelectedSlugs();

        $.ajax({
            url: ajaxurl,
            data: {
                action: 'filter_insights',
                terms: allSlugs,
                page,
                posts_per_page: postsPerPage,
            },
            type: 'GET',
            beforeSend() {
                $('.loader__block').css('display', 'block');
                blogCategory.addClass('disabled');
            },
            success(response) {
                $('.loader__block').css('display', 'none');

                if (response.success) {
                    blogCategory.removeClass('disabled');
                    blogCategory.html(response.data);
                } else {
                    blogCategory.html(
                        '<p>' +
                        (response.data && response.data.message
                            ? response.data.message
                            : 'No results') +
                        '</p>'
                    );
                }
            },
            error() {
                $('.loader__block').css('display', 'none');
                blogCategory.removeClass('disabled');
                if (!isInitializing) {
                    blogCategory.html('<p>Error loading results</p>');
                }
            },
            complete() {
                if (filterItem) {
                    filterItem.data('requestRunning', false);
                }

                checkSelectAllButton();

                if (!skipScroll) {
                    scrollToInsights();
                }

                if (window.innerWidth > 1200) {
                    $('.loader__block').css('top', '');
                }
            },
        });
    }

    $(document).on('click', '.filter-item', function (e) {
        e.preventDefault();
        const $this = $(this);

        if ($this.data('requestRunning')) {
            return;
        }

        const searchParams = new URLSearchParams(window.location.search);

        if (searchParams.has('current_page')) {
            searchParams.delete('current_page');
        }

        const newRelativePathQuery = window.location.pathname;

        const serviceType = $this.data('service-type');
        const industry = $this.data('industry');
        const expertise = $this.data('expertise');

        if ($this.hasClass('tab-item')) {
            if ($this.hasClass('active')) {
                return;
            }
            setTimeout(() => {
                serviceTypes.forEach((serviceType) => {
                    $(
                        '.tab-item[data-service-type="' + serviceType + '"]'
                    ).addClass('active');
                });

                industries.forEach((industry) => {
                    $('.tab-item[data-industry="' + industry + '"]').addClass(
                        'active'
                    );
                });

                expertises.forEach((expertise) => {
                    $('.tab-item[data-expertise="' + expertise + '"]').addClass(
                        'active'
                    );
                });
            }, 2000);
            clearAllFilters();
        }
        $('[data-service-type="' + serviceType + '"]').toggleClass('active');
        $('[data-industry="' + industry + '"]').toggleClass('active');
        $('[data-expertise="' + expertise + '"]').toggleClass('active');

        // Handle serviceType
        if (
            jQuery.inArray(serviceType, serviceTypes) === -1 &&
            serviceType !== undefined
        ) {
            serviceTypes.push(serviceType);
        } else if (serviceType !== undefined) {
            serviceTypes = jQuery.grep(serviceTypes, function (value) {
                return value !== serviceType;
            });
        }

        // Handle industry
        if (
            jQuery.inArray(industry, industries) === -1 &&
            industry !== undefined
        ) {
            industries.push(industry);
        } else if (industry !== undefined) {
            industries = jQuery.grep(industries, function (value) {
                return value !== industry;
            });
        }

        // Handle expertise
        if (
            jQuery.inArray(expertise, expertises) === -1 &&
            expertise !== undefined
        ) {
            expertises.push(expertise);
        } else if (expertise !== undefined) {
            expertises = jQuery.grep(expertises, function (value) {
                return value !== expertise;
            });
        }

        // Build URL with combined filters
        const allSlugs = getAllSelectedSlugs();

        // Remove path-based pagination from pathname (e.g., /page/3/)
        let cleanPathname = window.location.pathname.replace(
            /\/page\/\d+\/?$/,
            ''
        );
        cleanPathname =
            cleanPathname.replace(/\/$/, '') || '/trends-and-insights';

        // Build URL params, ensuring pagination params are removed
        const urlParams = new URLSearchParams();
        if (allSlugs.length > 0) {
            urlParams.set(
                'filters',
                allSlugs.map(encodeURIComponent).join(',')
            );
        }
        // Explicitly remove any pagination query params
        urlParams.delete('paged');
        urlParams.delete('page');

        const urlString = urlParams.toString();
        const newUrl = urlString
            ? cleanPathname + '?' + urlString
            : cleanPathname;

        history.pushState(null, '', newUrl);

        setSelectedFilterList();
        scrollResizeDesktop();
        checkScrollButton();

        if (window.innerWidth > 1200) {
            $this.data('requestRunning', true);
            ajaxQueryApply(1, $this); // Reset to page 1 when filters change
        } else if (!$('.sidebar__insights-mobile').hasClass('active')) {
            $this.data('requestRunning', true);
            ajaxQueryApply(1, $this); // Reset to page 1 when filters change
        }
    });

    $(document).on('click', '.js-filter-item__all', function (e) {
        e.preventDefault();

        let serviceTypesSelector = $('.js-filter-item_service_types:visible');
        let industriesSelector = $('.js-filter-item_industries:visible');
        let expertisesSelector = $('.js-filter-item_expertises:visible');

        const $this = $(this);
        $this.toggleClass('active');

        if ($this.hasClass('active')) {
            serviceTypesSelector = $(
                '.js-filter-item_service_types:visible:not(.active)'
            );
            industriesSelector = $(
                '.js-filter-item_industries:visible:not(.active)'
            );
            expertisesSelector = $(
                '.js-filter-item_expertises:visible:not(.active)'
            );
            $this.text('Clear all');
        } else {
            $this.text('Select all');
        }

        blogCategory.addClass('disabled');
        $('.loader__block').css('display', 'block');

        // Remove page number from path when filters change
        let cleanPathname = window.location.pathname.replace(
            /\/page\/\d+\/?$/,
            ''
        );
        cleanPathname =
            cleanPathname.replace(/\/$/, '') || '/trends-and-insights';

        const filterType = $this.data('filter');

        switch (filterType) {
            case 'service-type':
                $.each(serviceTypesSelector, function (index, item) {
                    const serviceType = $(item).data('service-type');
                    $(item).toggleClass('active');

                    if (
                        jQuery.inArray(serviceType, serviceTypes) === -1 &&
                        serviceType !== undefined
                    ) {
                        serviceTypes.push(serviceType);
                    } else {
                        serviceTypes = jQuery.grep(
                            serviceTypes,
                            function (value) {
                                return value !== serviceType;
                            }
                        );
                    }
                });
                break;
            case 'industries':
                $.each(industriesSelector, function (index, item) {
                    const industry = $(item).data('industry');
                    $(item).toggleClass('active');

                    if (
                        jQuery.inArray(industry, industries) === -1 &&
                        industry !== undefined
                    ) {
                        industries.push(industry);
                    } else {
                        industries = jQuery.grep(industries, function (value) {
                            return value !== industry;
                        });
                    }
                });
                break;
            case 'expertise':
                $.each(expertisesSelector, function (index, item) {
                    const expertise = $(item).data('expertise');
                    $(item).toggleClass('active');

                    if (
                        jQuery.inArray(expertise, expertises) === -1 &&
                        expertise !== undefined
                    ) {
                        expertises.push(expertise);
                    } else {
                        expertises = jQuery.grep(expertises, function (value) {
                            return value !== expertise;
                        });
                    }
                });
                break;
        }

        // Build URL with combined filters
        const allSlugs = getAllSelectedSlugs();
        let newUrl = cleanPathname;
        if (allSlugs.length > 0) {
            newUrl += '?filters=' + allSlugs.map(encodeURIComponent).join(',');
        }
        history.pushState(null, '', newUrl);

        setSelectedFilterList();
        scrollResizeDesktop();
        checkScrollButton();

        if (window.innerWidth > 1200) {
            ajaxQueryApply(1); // Reset to page 1 when filters change
        }
    });

    $('.filter__mobile-inside, .button__apply-filter-insights').on(
        'click',
        function (e) {
            e.preventDefault();

            ajaxQueryApply(1); // Reset to page 1 when filters change
        }
    );

    // Pagination click handler
    $(document).on('click', '.pagination__page', function (e) {
        // Don't handle clicks on disabled pagination items
        if ($(this).hasClass('disabled')) {
            return;
        }

        // Don't handle clicks on ellipsis (no link inside)
        if ($(this).find('.pagination__elipsis').length > 0) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        const $pageDiv = $(this);
        const $link = $pageDiv.find('a');

        // If no link found, don't proceed
        if (!$link.length) {
            return;
        }

        // Get page number from data attribute or href
        let pageNum = parseInt($pageDiv.data('paged'));
        if (isNaN(pageNum) || pageNum < 1) {
            const href = $link.attr('href');
            if (href) {
                const pageMatch = href.match(/\/page\/(\d+)/);
                if (pageMatch) {
                    pageNum = parseInt(pageMatch[1]);
                } else {
                    pageNum = 1;
                }
            } else {
                pageNum = 1;
            }
        }

        if (isNaN(pageNum) || pageNum < 1) {
            return;
        }

        const allSlugs = getAllSelectedSlugs();
        let cleanPathname = window.location.pathname.replace(
            /\/page\/\d+\/?$/,
            ''
        );
        cleanPathname =
            cleanPathname.replace(/\/$/, '') || '/trends-and-insights';

        let newUrl = cleanPathname;
        if (pageNum > 1) {
            newUrl += '/page/' + pageNum + '/';
        }
        if (allSlugs.length > 0) {
            newUrl += '?filters=' + allSlugs.map(encodeURIComponent).join(',');
        }

        history.pushState(null, '', newUrl);
        ajaxQueryApply(pageNum);
    });

    parseUrlParamsInit();

    function scrollResizeDesktop() {
        const scrollableContent = $(
            '.sidebar__result-filter__main .sidebar__result-filter-container'
        );
        let isDragging = false;
        let startPosition = 0;
        let scrollPosition = 0;

        scrollableContent.on('mousedown', function (event) {
            if (event.button === 0) {
                isDragging = true;
                startPosition = event.clientX;
                scrollPosition = scrollableContent.scrollLeft();
                event.preventDefault();
            }
        });

        $(document).on('mouseup', function (event) {
            if (event.button === 0) {
                isDragging = false;
                event.preventDefault();
            }
        });

        $(document).on('mousemove', function (event) {
            if (isDragging) {
                const distance = event.clientX - startPosition;
                scrollableContent.scrollLeft(scrollPosition - distance);
                event.preventDefault();
            }
        });
    }
    scrollResizeDesktop();

    function checkScrollButton() {
        const scrollContainer = document.querySelector(
            '.sidebar__result-filter__main .sidebar__result-filter-container'
        );
        if (scrollContainer) {
            if (
                scrollContainer.scrollLeft + scrollContainer.clientWidth >=
                scrollContainer.scrollWidth
            ) {
                $('.right-button-case').addClass('case-scroll-max');
            } else {
                $('.right-button-case').removeClass('case-scroll-max');
            }
            if (scrollContainer.scrollLeft <= 0) {
                $('.left-button-case').addClass('case-scroll-max');
            } else {
                $('.left-button-case').removeClass('case-scroll-max');
            }
        }
    }
    checkScrollButton();

    if (
        document.querySelector('.right-button-case') &&
        document.querySelector('.left-button-case')
    ) {
        document
            .querySelector('.right-button-case')
            .addEventListener('click', function () {
                const scrollContainer = document.querySelector(
                    '.sidebar__result-filter__main .sidebar__result-filter-container'
                );
                const scrollAmount = 100;
                const scrollDuration = 500;

                const startScrollLeft = scrollContainer.scrollLeft;
                const targetScrollLeft = startScrollLeft + scrollAmount;
                let startTime;

                function scroll(timestamp) {
                    if (!startTime) {
                        startTime = timestamp;
                    }

                    const elapsed = timestamp - startTime;

                    if (elapsed < scrollDuration) {
                        const progress = elapsed / scrollDuration;
                        scrollContainer.scrollLeft =
                            startScrollLeft + progress * scrollAmount;
                        requestAnimationFrame(scroll);
                    } else {
                        scrollContainer.scrollLeft = targetScrollLeft;
                    }
                }
                requestAnimationFrame(scroll);
                setTimeout(() => {
                    checkScrollButton();
                }, scrollDuration);
            });
        document
            .querySelector('.left-button-case')
            .addEventListener('click', function () {
                const scrollContainer = document.querySelector(
                    '.sidebar__result-filter__main .sidebar__result-filter-container'
                );
                const scrollAmount = 100;
                const scrollDuration = 500;

                const startScrollLeft = scrollContainer.scrollLeft;
                const targetScrollLeft = startScrollLeft - scrollAmount;
                let startTime;
                function scroll(timestamp) {
                    if (!startTime) {
                        startTime = timestamp;
                    }

                    const elapsed = timestamp - startTime;

                    if (elapsed < scrollDuration) {
                        const progress = elapsed / scrollDuration;
                        scrollContainer.scrollLeft =
                            startScrollLeft +
                            progress * (targetScrollLeft - startScrollLeft);
                        requestAnimationFrame(scroll);
                    } else {
                        scrollContainer.scrollLeft = targetScrollLeft;
                    }
                }
                requestAnimationFrame(scroll);
                setTimeout(() => {
                    checkScrollButton();
                }, scrollDuration);
            });
    }

    const scrollableElements = document.getElementsByClassName(
        'sidebar__result-filter-container'
    );

    if (scrollableElements && scrollableElements.length > 0) {
        for (let i = 0; i < scrollableElements.length; i++) {
            scrollableElements[i].addEventListener('scroll', function (event) {
                checkScrollButton();
            });
        }
    }
});
